import AddAndEditCustomerPage from "../../../../features/admin/customers/add-and-edit-customer-page/add-and-edit-customer-page";

export default function AddAndEditCustomer({ isEdit }: { isEdit: boolean }) {
  return <AddAndEditCustomerPage isEdit={isEdit} />;
}
